import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { Check, CollectionCheck } from "@frui.ts/bootstrap";
import DistributorRefundsViewModel from "viewModels/finance/refundApprovals/distributorRefunds/distributorRefundsViewModel";
import type DistrubutorRefundResponse from "entities/distributorRefundResponse";
import DistributorRefundsFilters from "./distributorRefundsFilters";
import type { ListColumnDefinition } from "../../../common/list";
import ListView from "../../../common/list";
import { ApprovalColumns } from "../../../common/approvalColumns";
import type DistributorPaymentRequestResponse from "entities/distributorPaymentRequestResponse";
import { formatAmount, formatDate } from "../../../../utils/localizations";

const DistributorRefundsView: ViewComponent<DistributorRefundsViewModel> = observer(({ vm }) => {
  const columns: ListColumnDefinition<DistrubutorRefundResponse>[] = [
    {
      title: <Check custom target={vm as { allItems?: boolean }} property="allItems" threeState={true} />,
      valueFormatter: props => {
        if (props.item.isSelectable) {
          return <CollectionCheck custom target={vm} property="selectedItems" disabled={false} value={props.item} />;
        }
      },
    },
    {
      title: vm.translateAttribute("distributorName"),
      property: "distributorName",
    },
    {
      title: vm.translateAttribute("variableSymbol"),
      property: "variableSymbol",
    },
    {
      title: vm.translateAttribute("distributorPaymentRequest"),
      property: "distributorPaymentRequest",
      valueFormatter: props => {
        const value: DistributorPaymentRequestResponse = props.value;
        return `${value.variableSymbol} -  ${formatDate(value.validSinceDate)} - ${vm.translateRequestType(value.type)}`;
      },
    },
    {
      title: vm.translateAttribute("amount"),
      property: "amount",
      valueFormatter: props => formatAmount(props.value),
    },
    ...ApprovalColumns<DistrubutorRefundResponse, DistributorRefundsViewModel>(vm),
  ];

  return (
    <>
      <DistributorRefundsFilters vm={vm} />
      <ListView columns={columns} vm={vm} showDetailWithList={true} hideTitle={true} hideButtons={true} />
    </>
  );
});

registerView(DistributorRefundsView, DistributorRefundsViewModel);
